import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块
const getIm = {
  playHongBao(params) {
    return axios.post(`/mobile/page/red_send_t`, qs.stringify(params));
  },
  getHongBao(params) {
    return axios.post(`/mobile/page/red_open_t`, qs.stringify(params));
  },
  infoHongBao(params) {
    return axios.post(`/mobile/page/order_user_t`, qs.stringify(params));
  },
  //查看战队
  getTeatList(params) {
    return axios.post(`/mobile/page/teamlists`, qs.stringify(params));
  },
  getTeamIndex(params) {
    return axios.post(`/mobile/page/teamindex`, qs.stringify(params));
  },
  addTeam(params) {
    return axios.post(`/mobile/page/add_team`, qs.stringify(params));
  },
  joinTeam(params) {
    return axios.post(`/mobile/page/join`, qs.stringify(params));
  },
  editTeam(params) {
    return axios.post(`/mobile/page/teamedit`, qs.stringify(params));
  },
  tOutTeam(params) {
    return axios.post(`/mobile/page/kick_out`, qs.stringify(params));
  },
  transferTeam(params) {
    return axios.post(`/mobile/page/transfer`, qs.stringify(params));
  },
  saveEaitTeam(params) {
    return axios.post(`/mobile/page/saveedit`, qs.stringify(params));
  },
  refuseTeam(params) {
    return axios.post(`/mobile/page/refuse`, qs.stringify(params));
  },
  byjoining(params) {
    return axios.post(`/mobile/page/byjoining`, qs.stringify(params));
  },
  delJoin(params) {
    return axios.post(`/mobile/page/del_join`, qs.stringify(params));
  },
  outTeam(params) {
    return axios.post(`/mobile/page/drop_out`, qs.stringify(params));
  },
  addRecom(params) {
    return axios.post(`/mobile/page/recommended`, qs.stringify(params));
  },
  getwelcome(params) {
    return axios.post(`/mobile/page/welcome`, qs.stringify(params));
  },
  sendMsg(params) {
    return axios.post(`/mobile/page/im_text`, qs.stringify(params));
  },
  getActivitMsg(params) {
    return axios.post(
      `/mobile/page/one_recommend_letter`,
      qs.stringify(params)
    );
  },
  getXtMsg(params) {
    return axios.post(`/mobile/page/one_letter`, qs.stringify(params));
  },
  sendMsgSms(params) {
    return axios.post(`/mobile/page/sms`, qs.stringify(params));
  },
  imBuddySearch(params) {
    return axios.post(`/mobile/page/search`, qs.stringify(params));
  },
  imBuddyApplications(params) {
    return axios.post(`/mobile/page/applications`, qs.stringify(params));
  },
  imBuddyAudits(params) {
    return axios.post(`/mobile/page/audit`, qs.stringify(params));
  },
  imBuddyBy(params) {
    return axios.post(`/mobile/page/by`, qs.stringify(params));
  },
  imBuddyLists(params) {
    return axios.post(`/mobile/page/KFlists`, qs.stringify(params));
  },
  imBuddyDel(params) {
    return axios.post(`/mobile/page/del`, qs.stringify(params));
  },

  //编辑备注
  edit_remark(params) {
    return axios.post(`/mobile/page/remark`, qs.stringify(params));
  },

  //获取用户信息
  get_frinedinfo(params) {
    return axios.post(`/mobile/page/friend_data`, qs.stringify(params));
  },
  //创建群聊
  create_team(params) {
    return axios.post(`/mobile/page/im_team_work`, qs.stringify(params));
  },
  //退出
  exit_team(params) {
    return axios.post(`/mobile/page/drop_out_im`, qs.stringify(params));
  },
  //自己的申请加群列表
  my_teamapply(params) {
    return axios.post(`/mobile/page/im_team_work`, qs.stringify(params));
  },
  //取消自己的申请
  cancel_my_teamapply(params) {
    return axios.post(`/mobile/page/del_join`, qs.stringify(params));
  },

  pick_friend_inteam(params) {
    return axios.post(`/mobile/page/pick_up_friends`, qs.stringify(params));
  },

  //删除好友
  del_myfriend(params) {
    return axios.post(`/mobile/page/del_buddy`, qs.stringify(params));
  },

  //发送群红包
  send_team_redbag(params) {
    return axios.post(`/mobile/page/red_send`, qs.stringify(params));
  },
  open_team_redbag(params) {
    return axios.post(`/mobile/page/red_open`, qs.stringify(params));
  },
};

export default getIm;



// WEBPACK FOOTER //
// ./src/assets/js/api/require/im.js